import { fetchWrapper } from '../Helpers';


export const reviewService = {
  getReviewByOfferId,
  addReview
};


function getReviewByOfferId(id) {
  return fetchWrapper.get(
    // `${process.env.REACT_APP_API_URL}/reviews/submitted/offer/${id}`
    `${process.env.REACT_APP_API_URL}/offers/${id}/given-review`
  );
}

function addReview(param) {
  // return fetchWrapper.post(`${process.env.REACT_APP_API_URL}/reviews`, param);
return fetchWrapper.post(`${process.env.REACT_APP_API_URL}/offers/${param?.offer_id}/reviews`, param);

}





